import { Suspense } from "react";
import { CircularProgress, MenuItem } from "@mui/material";
import { LocationSearchGeopunt } from "./LocationSearchGeopunt";
import { LocationSearchNominatim } from "./LocationSearchNominatim";

import { LocationResult, SelectedLocationState } from "../../types";

interface Props {
  type: string;
  query: string;
  onSelect: (result: LocationResult) => void;
  selected: SelectedLocationState;
  setSelected: (selected: SelectedLocationState) => void;
}

export function LocationSearchResults(props: Props) {
  const { type, query, onSelect, selected, setSelected } = props;
  return (
    <Suspense
      fallback={
        <MenuItem sx={{ justifyContent: "center" }}>
          <CircularProgress />
        </MenuItem>
      }
    >
      {type === "geopunt" && (
        <LocationSearchGeopunt
          query={query}
          onSelect={onSelect}
          selected={selected}
          setSelected={setSelected}
        />
      )}
      {type === "nominatim" && (
        <LocationSearchNominatim
          query={query}
          onSelect={onSelect}
          selected={selected}
          setSelected={setSelected}
        />
      )}
    </Suspense>
  );
}
